// Force page.chat template on Charli page
document.addEventListener("DOMContentLoaded", function () {
  const isCharliPage = window.location.pathname.includes("/pages/charli");
  const isConferenciaPage =
    window.location.pathname.includes("/pages/conferencia");
  // Check if we're on the Charli page
  if (isCharliPage || isConferenciaPage) {
    console.log(
      "On Charli or Conferencia page, checking if chat interface should be added"
    );

    // Hide footer on Charli page
    const footer = document.querySelector("footer");
    if (footer) {
      footer.style.display = "none";
    }

    // Option 1: Try URL parameter approach
    const currentUrl = new URL(window.location.href);
    if (!currentUrl.searchParams.has("template")) {
      currentUrl.searchParams.set("template", "page.chat");
      console.log("Redirecting to: " + currentUrl.toString());
      window.location.href = currentUrl.toString();
      return; // Exit early since we're redirecting
    }

    // Option 2: If URL parameter didn't work (we're already on a URL with template param)
    // Wait a short time to make sure the page is fully loaded
    // Check if chat interface is already present
    if (!document.querySelector(".chat-interface")) {
      console.log("Chat interface not found, manually inserting it");

      // Add CSS style to head
      if (!document.getElementById("chat-interface-styles")) {
        const styleTag = document.createElement("style");
        styleTag.id = "chat-interface-styles";
        styleTag.textContent = `
            /* Apple Garamond font import */
            @font-face {
              font-family: 'Apple Garamond';
              src: url('https://cdn.shopify.com/s/files/1/0582/0811/9978/files/AppleGaramond-Light.woff2') format('woff2'),
                   url('https://cdn.shopify.com/s/files/1/0582/0811/9978/files/AppleGaramond-Light.woff') format('woff');
              font-weight: 300;
              font-style: normal;
              font-display: swap;
            }
            
            @font-face {
              font-family: 'Apple Garamond';
              src: url('https://cdn.shopify.com/s/files/1/0582/0811/9978/files/AppleGaramond.woff2') format('woff2'),
                   url('https://cdn.shopify.com/s/files/1/0582/0811/9978/files/AppleGaramond.woff') format('woff');
              font-weight: normal;
              font-style: normal;
              font-display: swap;
            }
            
            @font-face {
              font-family: 'Apple Garamond';
              src: url('https://cdn.shopify.com/s/files/1/0582/0811/9978/files/AppleGaramond-Bold.woff2') format('woff2'),
                   url('https://cdn.shopify.com/s/files/1/0582/0811/9978/files/AppleGaramond-Bold.woff') format('woff');
              font-weight: bold;
              font-style: normal;
              font-display: swap;
            }
            
            .chat-interface {
              display: flex !important;
              flex-direction: column !important;
              position: fixed !important;
              top: var(--header-height, 70px) !important;
              left: 0 !important;
              right: 0 !important;
              bottom: 0 !important;
              width: 100vw !important;
              height: calc(100dvh - var(--header-height, 70px)) !important;
              z-index: 1 !important;
              background-color: rgb(var(--color-background)) !important;
            }
            
            .chat-interface__container {
              display: flex !important;
              flex-direction: column !important;
              height: 100% !important;
              width: 100% !important;
              position: relative !important;
            }
            
            .chat-interface__messages {
              flex: 1 !important;
              overflow-y: auto !important;
              overflow-x: hidden !important;
              padding: 40px 40px 100px 40px !important;
              display: flex !important;
              flex-direction: column !important;
              gap: 20px !important;
              position: relative !important;
              box-sizing: border-box !important;
              width: 100% !important;
              height: 0 !important; /* Force flex item to respect flex: 1 */
              
              /* Hide scrollbar but keep functionality */
              scrollbar-width: none !important; /* Firefox */
              -ms-overflow-style: none !important; /* Internet Explorer 10+ */
            }
            
            /* Hide scrollbar for Chrome, Safari and Opera */
            .chat-interface__messages::-webkit-scrollbar {
              display: none !important;
            }
            
            .chat-interface__welcome {
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-top: 40px;
              margin-bottom: 20px;
              width: 100%;
              text-align: center;
              flex-shrink: 0;
            }
            
            .chat-interface__logo {
              width: 140px;
              height: 140px;
            }
            
            .chat-interface__welcome-title {
              font-size: 42px;
              font-weight: 400;
              margin-bottom: 15px;
              text-align: center;
              font-family: 'Apple Garamond', Georgia, serif;
              line-height: 100%;
              letter-spacing: 0%;
              vertical-align: middle;
            }
            
            .chat-interface__welcome-text {
              font-size: 16px;
              text-align: center;
              max-width: 500px;
              margin: 0 auto 30px;
              line-height: 1.5;
              font-family: 'Apple Garamond', Georgia, serif;
            }
            
            .chat-empty-state {
              position: relative;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              opacity: 1;
              transition: opacity 0.3s ease;
              width: 100%;
              text-align: center;
              margin-top: 20px;
              margin-bottom: 20px;
            }
            
            .chat-empty-state img {
              max-width: 160px;
              height: auto;
            }
            
            .chat-message {
              display: flex;
              gap: 12px;
              max-width: 90%;
              width: 100%;
            }
            
            .chat-message--user {
              align-self: flex-end;
              flex-direction: row-reverse;
              justify-content: flex-start;
              text-align: right;
            }
            
            .chat-message--bot {
              align-self: flex-start;
              justify-content: flex-start;
              text-align: left;
            }
            
            .chat-message__avatar {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              overflow: hidden;
              flex-shrink: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: bold;
              background-color: rgb(var(--color-background));
              border: 1px solid rgba(var(--color-foreground), 0.1);
            }
            
            .chat-message__avatar img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            
            .chat-message--user .chat-message__avatar {
              background-color: rgb(var(--color-base-accent-1));
              color: rgb(var(--color-base-accent-1-contrast));
            }
            
            .chat-message__content {
              background-color: rgba(var(--color-foreground), 0.04);
              padding: 12px 16px;
              border-radius: 12px;
              color: rgb(var(--color-foreground));
              font-size: 14px;
              line-height: 1.5;
              font-family: 'Apple Garamond', Georgia, serif;
            }
            
            .chat-message--user .chat-message__content {
              background-color: rgb(var(--color-base-accent-1));
              color: rgb(var(--color-base-accent-1-contrast));
            }

            .chat-message__content p {
              margin: 0 0 10px;
            }

            .chat-message__content p:last-child {
              margin-bottom: 0;
            }
            
            .chat-interface__input-container {
              border-top: 1px solid rgba(var(--color-foreground), 0.04) !important;
              padding: 24px !important;
              background: linear-gradient(180deg, 
                          rgba(var(--color-background), 0.98) 0%, 
                          rgba(var(--color-background), 1) 100%) !important;
              backdrop-filter: blur(20px) saturate(180%) !important;
              position: relative !important;
              width: 100% !important;
              min-height: 96px !important;
              flex-shrink: 0 !important;
              box-sizing: border-box !important;
              box-shadow: 0 -4px 20px rgba(var(--color-foreground), 0.02) !important;
            }
            
            .chat-interface__form {
              display: flex;
              align-items: flex-end;
              gap: 12px;
              position: relative;
              max-width: 100%;
              margin: 0 auto;
              width: 100%;
              padding: 0 20px;
            }
            
            .chat-interface__input {
              flex: 1;
              border: 2px solid rgba(var(--color-foreground), 0.08);
              border-radius: 28px;
              padding: 16px 50px 16px 24px;
              font-size: 12px;
              line-height: 1.5;
              resize: none;
              max-height: 120px;
              min-height: 56px;
              background-color: rgb(var(--color-background));
              color: rgb(var(--color-foreground));
              font-family: 'Apple Garamond', Georgia, serif;
              overflow-y: hidden;
              transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
              box-shadow: 0 4px 12px rgba(var(--color-foreground), 0.04),
                          inset 0 1px 0 rgba(255, 255, 255, 0.1);
              font-weight: 400;
              -webkit-text-size-adjust: 100%;
            }
            
            .chat-interface__input.with-refresh {
              padding-right: 90px;
            }
            
            .chat-interface__input::placeholder {
              font-family: 'Apple Garamond', Georgia, serif;
              color: rgba(var(--color-foreground), 0.45);
              font-weight: 400;
            }
            
            .chat-interface__input:focus {
              outline: none;
              border-color: rgb(var(--color-base-accent-1));
              background-color: rgb(var(--color-background));
              box-shadow: 0 8px 24px rgba(var(--color-foreground), 0.06), 
                          0 0 0 4px rgba(var(--color-base-accent-1), 0.08);
              transform: translateY(-2px);
            }
            
            .chat-interface__input:hover:not(:focus) {
              border-color: rgba(var(--color-foreground), 0.15);
              box-shadow: 0 6px 16px rgba(var(--color-foreground), 0.06),
                          inset 0 1px 0 rgba(255, 255, 255, 0.1);
              transform: translateY(-1px);
            }
            
            .chat-interface__input-actions {
              right: 12px;
              top: 50%;
              transform: translateY(-50%);
              display: flex;
              align-items: center;
              gap: 8px;
              z-index: 2;
              transition: top 0.2s ease;
            }
            
            .chat-interface__submit-button {
              background: linear-gradient(135deg, rgb(var(--color-base-accent-1)), rgba(var(--color-base-accent-1), 0.8));
              color: rgb(var(--color-base-accent-1-contrast));
              border: none;
              border-radius: 50%;
              width: 36px;
              height: 36px;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              transition: all 0.2s ease;
              position: absolute;
              right: 32px;
              top: 50%;
              transform: translateY(-50%);
            }
            
            .chat-interface__submit-button:hover {
              background: rgba(var(--color-foreground), 0.8);
            }
            
            .chat-interface__submit-button svg {
              width: 16px;
              height: 16px;
            }
            
            .chat-interface__refresh-button {
              background: rgba(var(--color-foreground), 0.06);
              border: none;
              border-radius: 50%;
              cursor: pointer;
              padding: 0;
              width: 32px;
              height: 32px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: rgba(var(--color-foreground), 0.65);
              transition: all 0.2s ease;
            }

            .chat-interface__refresh-button:hover {
              background: rgba(var(--color-foreground), 0.1);
              color: rgb(var(--color-foreground));
              transform: scale(1.05);
            }
            
            .chat-interface__refresh-button:active {
              transform: scale(0.95);
            }

            .chat-interface__refresh-button svg {
              width: 14px;
              height: 14px;
            }
            
            .typing-indicator {
              display: flex;
              align-items: center;
              gap: 4px;
              padding: 12px 16px;
              background-color: rgba(var(--color-foreground), 0.04);
              border-radius: 12px;
              width: fit-content;
            }
            
            .typing-indicator__dot {
              width: 8px;
              height: 8px;
              background-color: rgba(var(--color-foreground), 0.5);
              border-radius: 50%;
              animation: typing-animation 1.4s infinite ease-in-out;
            }
            
            .typing-indicator__dot:nth-child(1) {
              animation-delay: 0s;
            }
            
            .typing-indicator__dot:nth-child(2) {
              animation-delay: 0.2s;
            }
            
            .typing-indicator__dot:nth-child(3) {
              animation-delay: 0.4s;
            }
            
            @keyframes typing-animation {
              0%, 100% {
                transform: translateY(0);
              }
              50% {
                transform: translateY(-5px);
              }
            }
            
            /* Mobile styles */
            @media screen and (max-width: 768px) {
              .chat-interface {
                top: var(--header-height, 60px) !important;
                height: calc(100dvh - var(--header-height, 60px)) !important;
              }
              
              .chat-interface__messages {
                padding: 20px 20px 110px 20px !important;
              }
              
              .chat-interface__form {
                padding: 0 16px !important;
              }
              
              .chat-interface__input {
                font-size: 12px !important;
                padding: 14px 50px 14px 18px !important;
                min-height: 50px !important;
                border-radius: 24px !important;
                word-wrap: break-word !important;
                overflow-wrap: break-word !important;
                word-break: break-word !important;
                -webkit-text-size-adjust: 100% !important;
              }
              
              .chat-interface__input.with-refresh {
                padding-right: 80px !important;
              }
              
              .chat-interface__input-actions {
                right: 10px;
                gap: 6px;
              }
              
              .chat-interface__submit-button {
                width: 32px !important;
                height: 32px !important;
              }
              
              .chat-interface__refresh-button {
                width: 28px !important;
                height: 28px !important;
              }
              
              .chat-interface__welcome-title {
                font-size: 36px !important;
              }
              
              .chat-interface__welcome-text {
                font-size: 16px !important;
              }
              
              .chat-empty-state img {
                max-width: 140px !important;
              }
            }

            /* Tablet styles */
            @media screen and (min-width: 769px) and (max-width: 1024px) {
              .chat-interface__messages {
                padding: 40px 60px 110px 60px !important;
                max-width: 900px !important;
                margin: 0 auto !important;
              }
              
              .chat-message {
                max-width: 85% !important;
              }
              
              .chat-interface__form {
                max-width: 900px !important;
                margin: 0 auto !important;
                padding: 0 60px !important;
              }
              
              .chat-interface__welcome-title {
                font-size: 48px !important;
              }
              
              .chat-interface__welcome-text {
                font-size: 18px !important;
                max-width: 600px !important;
              }
              
              .chat-empty-state img {
                max-width: 160px !important;
              }
            }

            /* Desktop styles */
            @media screen and (min-width: 1025px) {
              .chat-interface__messages {
                padding: 60px 100px 110px 100px !important;
                max-width: 1200px !important;
                margin: 0 auto !important;
              }
              
              .chat-message {
                max-width: 80% !important;
              }
              
              .chat-interface__form {
                max-width: 1200px !important;
                margin: 0 auto !important;
                padding: 0 100px !important;
              }
              
              .chat-interface__welcome-title {
                font-size: 52px !important;
              }
              
              .chat-interface__welcome-text {
                font-size: 20px !important;
                max-width: 700px !important;
              }
              
              .chat-empty-state img {
                max-width: 180px !important;
              }
            }


            
            html, body {
              height: 100% !important;
              margin: 0 !important;
              padding: 0 !important;
            }
            
            body {
              overflow: hidden !important;
            }
            
            #MainContent {
              padding-bottom: 0 !important;
              padding: 0 !important;
              margin: 0 !important;
              height: 100dvh !important;
              width: 100% !important;
              position: relative !important;
            }

            /* Additional overrides for Shopify theme interference */
            .chat-interface * {
              box-sizing: border-box !important;
            }

            .chat-interface .container,
            .chat-interface [class*="container"],
            .chat-interface [class*="wrapper"] {
              max-width: 100% !important;
              width: 100% !important;
              margin: 0 !important;
            }
          `;
        document.head.appendChild(styleTag);
      }

      // Find the main content area
      const mainContent = document.getElementById("MainContent");
      if (mainContent) {
        // Dynamically set header height for CSS calc()
        const header = document.querySelector("header");
        let headerHeight = 70; // Default fallback

        if (header) {
          headerHeight = header.offsetHeight;
        }

        // Set responsive header height based on screen size
        if (window.innerWidth <= 768) {
          headerHeight = Math.min(headerHeight, 60); // Smaller on mobile
        }

        document.documentElement.style.setProperty(
          "--header-height",
          `${headerHeight}px`
        );

        // Get the image URL from global variable set in theme.liquid
        const charliImageUrl =
          window.CHARLI_ASSETS?.ojosGrandesGif || "/assets/ojos-grandes.gif";
        console.log("Charli image URL:", charliImageUrl);
        console.log("CHARLI_ASSETS:", window.CHARLI_ASSETS);

        // Create chat interface container
        const chatContainer = document.createElement("div");
        chatContainer.className =
          "chat-interface color-background-1 background";
        chatContainer.innerHTML = `
            <div class="chat-interface__container">
              <div class="chat-interface__messages" id="chat-messages">
                <div class="chat-interface__welcome">
                  <div class="chat-empty-state" id="chat-empty-state">
                    <img src="${charliImageUrl}" alt="Charli esperando" 
                         onload="console.log('Image loaded successfully:', this.src)"
                         onerror="console.error('Image failed to load:', this.src, this.error)" />
                  </div>
                  <p class="chat-interface__welcome-title">Oi, eu sou o Charli, seu barista digital.</p>
                  <p class="chat-interface__welcome-text">Quer saber qual é o seu match perfeito de café? Bora trocar uma ideia que eu te conto.</p>
                </div>
              </div>
              
              <div class="chat-interface__input-container">
                <form id="chat-form" class="chat-interface__form">
                  <textarea 
                    id="chat-input" 
                    class="chat-interface__input" 
                    placeholder="Me pergunta o que quiser..." 
                    rows="1"
                    aria-label="Mensagem para Charli Bot"></textarea>
                  <button type="submit" class="chat-interface__submit-button" aria-label="Enviar mensaje">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <line x1="22" y1="2" x2="11" y2="13"></line>
                      <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                    </svg>
                  </button>
                </form>
              </div>
            </div>
          `;

        // Clear existing content and replace with our chat interface
        mainContent.innerHTML = "";
        mainContent.appendChild(chatContainer);
        // Initialize the chat interface behavior
        initChatInterface();

        // Handle window resize to update header height
        window.addEventListener("resize", () => {
          const header = document.querySelector("header");
          let headerHeight = 70;

          if (header) {
            headerHeight = header.offsetHeight;
          }

          if (window.innerWidth <= 768) {
            headerHeight = Math.min(headerHeight, 60);
          }

          document.documentElement.style.setProperty(
            "--header-height",
            `${headerHeight}px`
          );
        });
      }
    }
  }
});

// Function to initialize chat interface behavior
function initChatInterface() {
  const chatForm = document.getElementById("chat-form");
  const chatInput = document.getElementById("chat-input");
  const chatMessages = document.getElementById("chat-messages");
  const chatEmptyState = document.getElementById("chat-empty-state");
  const chatWelcome = document.querySelector(".chat-interface__welcome");

  if (!chatForm || !chatInput || !chatMessages) {
    console.error("Chat interface elements not found");
    return;
  }

  console.log("Initializing chat interface");

  let conversationId = `user_${Date.now()}_${Math.random()
    .toString(36)
    .substring(2, 9)}`;
  let conversationHistory = [];

  // Function to check if chat is empty and show/hide empty state
  function checkChatEmpty() {
    // If we have only one message or none, show empty state
    if (chatMessages.querySelectorAll(".chat-message").length === 0) {
      chatEmptyState.classList.add("visible");
    } else {
      chatEmptyState.classList.remove("visible");
    }
  }

  // Check initial state
  checkChatEmpty();

  // Auto-resize textarea as user types
  chatInput.addEventListener("input", () => {
    chatInput.style.height = "auto";
    chatInput.style.height = `${Math.min(chatInput.scrollHeight, 150)}px`;

    // Move the buttons to stay centered vertically with the input
    const inputActions = document.getElementById("chat-input-actions");

    if (inputActions) {
      // Base offset is 56px, this keeps buttons vertically centered
      inputActions.style.top = `calc(50% + ${
        (chatInput.offsetHeight - 56) / 2
      }px)`;
    }
  });

  // Add event listener for Enter key to send message
  chatInput.addEventListener("keydown", (e) => {
    // If Enter is pressed without Shift key, send the message
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault(); // Prevent default (new line)
      chatForm.dispatchEvent(new Event("submit")); // Submit the form
    }
  });

  // Handle form submission
  chatForm.addEventListener("submit", async (e) => {
    e.preventDefault();

    const message = chatInput.value.trim();
    if (!message) return;

    // Hide welcome message on first user interaction
    if (chatWelcome && chatWelcome.style.display !== "none") {
      chatWelcome.style.display = "none";
    }

    // Clear input and reset height
    chatInput.value = "";
    chatInput.style.height = "auto";

    // Reset button positions
    const inputActions = document.getElementById("chat-input-actions");

    if (inputActions) {
      inputActions.style.top = "50%";
    }

    // Add user message to UI
    addMessage(message, "user");

    // Show typing indicator
    showTypingIndicator();

    try {
      // Send message to API
      const response = await sendMessage(message);

      // Remove typing indicator
      hideTypingIndicator();

      // Add bot response to UI
      addMessage(response, "bot");
    } catch (error) {
      console.error("Error sending message:", error);

      // Remove typing indicator
      hideTypingIndicator();

      // Show error message
      addMessage(
        "Lo siento, ha ocurrido un error. Por favor, inténtalo de nuevo más tarde.",
        "bot"
      );
    }
  });

  // Function to scroll to the bottom of chat
  function scrollToBottom() {
    requestAnimationFrame(() => {
      chatMessages.scrollTop = chatMessages.scrollHeight;
    });
  }

  // Function to add a message to the chat UI
  function addMessage(message, sender) {
    // Create message element
    const messageEl = document.createElement("div");
    messageEl.classList.add("chat-message", `chat-message--${sender}`);

    // Create avatar element
    const avatarEl = document.createElement("div");
    avatarEl.classList.add("chat-message__avatar");

    const ojosImageUrl =
      window.CHARLI_ASSETS?.ojosGrandesGif || "/assets/ojos-grandes.gif";

    if (sender === "bot") {
      // Use the image avatar
      console.log("Bot avatar image URL:", ojosImageUrl);
      avatarEl.innerHTML = `<img src="${ojosImageUrl}" alt="Charli" 
                                onload="console.log('Bot avatar loaded:', this.src)"
                                onerror="console.error('Bot avatar failed:', this.src)" />`;
    } else {
      // User avatar
      avatarEl.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><circle cx="20" cy="20" r="20" fill="currentColor"/><text x="50%" y="50%" text-anchor="middle" dy=".3em" fill="white" font-size="16" font-weight="bold"></text></svg>';
    }

    // Create content element
    const contentEl = document.createElement("div");
    contentEl.classList.add("chat-message__content");

    // Process message content (handle line breaks, etc.)
    message.split("\n").forEach((paragraph) => {
      if (paragraph.trim()) {
        const p = document.createElement("p");
        // Convert markdown bold to HTML bold
        p.innerHTML = paragraph
          .replace(/\*\*\*(.*?)\*\*\*/g, "<b>$1</b>")
          .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>");
        contentEl.appendChild(p);
      }
    });

    // Assemble message
    messageEl.appendChild(avatarEl);
    messageEl.appendChild(contentEl);

    // Add to chat
    chatMessages.appendChild(messageEl);

    // Update empty state
    checkChatEmpty();

    // Scroll to bottom to show new message
    scrollToBottom();

    // If it's a user message, add to conversation history
    if (sender === "user") {
      conversationHistory.push({
        role: "user",
        content: message,
      });
    } else if (sender === "bot") {
      conversationHistory.push({
        role: "assistant",
        content: message,
      });
    }
  }

  // Function to show typing indicator
  function showTypingIndicator() {
    const typingIndicator = document.createElement("div");
    typingIndicator.classList.add("typing-indicator");
    typingIndicator.setAttribute("id", "typing-indicator");

    for (let i = 0; i < 3; i++) {
      const dot = document.createElement("div");
      dot.classList.add("typing-indicator__dot");
      typingIndicator.appendChild(dot);
    }

    chatMessages.appendChild(typingIndicator);

    // Scroll to bottom
    scrollToBottom();
  }

  // Function to hide typing indicator
  function hideTypingIndicator() {
    const typingIndicator = document.getElementById("typing-indicator");
    if (typingIndicator) {
      typingIndicator.remove();

      // Scroll to bottom
      scrollToBottom();
    }
  }

  // Function to send message to API
  async function sendMessage(message) {
    // Check internet connectivity first
    if (!navigator.onLine) {
      console.error("No internet connection");
      return "Parece que no hay conexión a internet. Por favor, verifica tu conexión y vuelve a intentarlo.";
    }

    const isConferenciaPage =
      window.location.pathname.includes("/pages/conferencia");
    const apiUrl = isConferenciaPage
      ? "https://nw65nuudr2.execute-api.us-east-2.amazonaws.com/prod/chat/bot-conferencia"
      : "https://nw65nuudr2.execute-api.us-east-2.amazonaws.com/prod/chat/charli-web";

    const requestBody = {
      query: message,
      conversationId: conversationId,
      conversationHistory: conversationHistory.map((msg) => ({
        role: msg.role,
        content: msg.content,
      })),
    };

    try {
      console.log("Sending message to API:", apiUrl);
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        mode: "cors",
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        console.error("API error:", response.status, response.statusText);
        throw new Error(`API responded with status: ${response.status}`);
      }

      const data = await response.json();
      return (
        data.response ||
        data.message ||
        "No pude entender tu mensaje. ¿Podrías reformularlo?"
      );
    } catch (error) {
      console.error("Error sending message to API:", error);

      // DNS resolution error
      if (error.message && error.message.includes("ERR_NAME_NOT_RESOLVED")) {
        console.error("DNS resolution error - cannot resolve API domain");
        return "Lo siento, no puedo conectarme al servidor (error: DNS no resuelto). Por favor, verifica la URL del API y tu conexión a internet.";
      }

      // CORS error
      if (
        error.message &&
        (error.message.includes("CORS") ||
          error.message.includes("cross-origin"))
      ) {
        return "Lo siento, hay un problema de comunicación entre el sitio web y el servidor. Por favor, contacta al soporte técnico con el error: CORS.";
      }

      return "Lo siento, ha ocurrido un error al comunicarme con el servidor. Por favor, inténtalo de nuevo más tarde.";
    }
  }

  // Auto-focus input
  chatInput.focus();

  // Initial scroll to ensure proper positioning
  setTimeout(() => {
    scrollToBottom();
  }, 100);
}
